/**
 * PVJ Wishlist popover
 * --------------------
 * Saving a piece from the product page gets the same corner confirmation the
 * basket gives when something is added to the bag: a card under the header
 * icons that fades in, holds, and fades out on its own.
 *
 * It is deliberately the theme's own popover rather than a lookalike. The
 * holder reuses `.header-cart-popover` and the card reuses `.popover-inner`
 * and friends, so position, border, colours, type and the 0.2s fade all come
 * from theme.css - if the theme restyles its cart popover, this follows.
 * Timings below mirror `cart-popover` in theme.js.
 *
 * The holder is built here rather than added to sections/header.liquid so the
 * whole feature stays in the two PVJ files, and it lands in whichever header
 * layout is rendered.
 *
 * This file only reacts to the wishlist; it never writes to it.
 * assets/pvj-wishlist.js remains the single source of truth for the list.
 */
(function () {
  'use strict';

  // Both match cart-popover in theme.js: visible for 3s, emptied 300ms after
  // the fade starts (the fade itself is 0.2s, set on .header-cart-popover).
  var VISIBLE_MS = 3000;
  var CLEAR_MS = 300;

  var holder = null;
  var hideTimer = null;
  var clearTimer = null;

  function isMobile() {
    // The theme suppresses its own popover on mobile, where the cart drawer
    // takes over. Match that rather than covering a small screen.
    return Boolean(window.theme && window.theme.isMobile && window.theme.isMobile());
  }

  function wishlistUrl() {
    var link = document.querySelector('.wishlistToggle');
    return (link && link.getAttribute('href')) || null;
  }

  function getHolder() {
    if (holder && document.body.contains(holder)) return holder;

    var header = document.querySelector('.site-header');
    if (!header) return null;

    holder = document.createElement('div');
    holder.className = 'header-cart-popover header-wishlist-popover';
    holder.setAttribute('data-pvj-wishlist-popover', '');

    // The cart popover opens the cart drawer when clicked; this opens the
    // wishlist page, so the card is a way in rather than just a message.
    holder.addEventListener('click', function () {
      var url = wishlistUrl();
      if (url) window.location.href = url;
    });

    header.appendChild(holder);
    return holder;
  }

  function buildCard(button, saved) {
    var title = button.getAttribute('data-title') || '';
    var image = button.getAttribute('data-image') || '';
    var price = button.getAttribute('data-price') || '';
    var message =
      button.getAttribute(saved ? 'data-message-added' : 'data-message-removed') ||
      (saved ? 'added to your wishlist' : 'removed from your wishlist');

    var inner = document.createElement('div');
    inner.className = 'popover-inner';

    var heading = document.createElement('div');
    heading.className = 'popover-item-heading';
    heading.textContent = title ? title + ' ' + message : message;
    inner.appendChild(heading);

    if (image) {
      var thumb = document.createElement('div');
      thumb.className = 'popover-item-thumb';

      var wrapper = document.createElement('div');
      wrapper.className = 'image-wrapper lazy-image';
      wrapper.style.setProperty('--aspect-ratio', '1');

      var img = document.createElement('img');
      img.src = image;
      img.alt = title;
      img.width = 120;
      img.height = 120;
      img.sizes = '120px';

      wrapper.appendChild(img);
      thumb.appendChild(wrapper);
      inner.appendChild(thumb);
    }

    var info = document.createElement('div');
    info.className = 'popover-item-info';

    var name = document.createElement('span');
    name.className = 'popover-item-title';
    name.textContent = title;
    info.appendChild(name);

    var amount = document.createElement('span');
    amount.className = 'popover-item-price';
    amount.textContent = price;
    info.appendChild(amount);

    inner.appendChild(info);
    return inner;
  }

  function hide() {
    if (!holder) return;

    holder.classList.remove('is-visible');

    window.clearTimeout(clearTimer);
    clearTimer = window.setTimeout(function () {
      if (holder && !holder.classList.contains('is-visible')) holder.innerHTML = '';
    }, CLEAR_MS);
  }

  function show(button, saved) {
    if (isMobile()) return;

    var target = getHolder();
    if (!target) return;

    // Both popovers are pinned to the same corner, so only one at a time.
    var cartPopover = document.querySelector('cart-popover [data-popover]');
    if (cartPopover) cartPopover.classList.remove('is-visible');

    window.clearTimeout(hideTimer);
    window.clearTimeout(clearTimer);

    target.innerHTML = '';
    target.appendChild(buildCard(button, saved));
    target.classList.add('is-visible');

    hideTimer = window.setTimeout(hide, VISIBLE_MS);
  }

  /**
   * The bookmark's own click handler (assets/pvj-wishlist.js) has already run
   * and updated the list by the time this bubbles up to the document, so the
   * saved state read here is the state after the toggle.
   *
   * Scoped to the product page bookmark. On the wishlist page a tile removes
   * itself when un-saved, which is confirmation enough.
   */
  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;

    var button = event.target.closest('pvj-wishlist-button.pvj-wishlist-button--title');
    if (!button || !window.PVJWishlist) return;

    show(button, window.PVJWishlist.has(button.getAttribute('data-handle')));
  });
})();
